export const COMPASS_PRODUCT_LINK = 'https://www.atlassian.com/software/compass';
